export function dateNow() {
  return Date.now();
}
export function getCurrentTimestamp() {
  return new Date().toISOString();
}
export function timestampToIsoString(value) {
  return new Date(value).toISOString();
}
